import React from 'react';
import PropTypes from 'prop-types';
import { ProgressCircular } from '@americanexpress/dls-react';

const Loading = ({ size, containerClassName }) => {
  return (
    <div
      className={containerClassName}
      role="alert"
      aria-label="Loading, please wait."
    >
      <ProgressCircular size={size} />
    </div>
  );
};

Loading.propTypes = {
  size: PropTypes.string,
  containerClassName: PropTypes.string,
};

export default Loading;
